/// <reference types="vite/client" />
export const env = (key: string): string => {
  return import.meta.env[`VITE_${key}`] || "";
};
